/* eslint-disable jsx-a11y/label-has-associated-control */

'use client';

import { FC, useId } from 'react';

import { useTheme } from 'styled-components';

import { ICheckboxProps } from './types';
import { Container, CheckboxSquare, CustomInput, Label } from './styles';
import { Icon } from '../../Icons';

export const Checkbox: FC<ICheckboxProps> = ({
  onToggle,
  name,
  isChecked,
  id: _id,
  isDisabled = false,
  labelAs = 'label',
  indeterminate = false,
}) => {
  const theme = useTheme();
  const reactId = useId();
  const id = _id || reactId;

  return (
    <Container>
      <Label htmlFor={id} as={labelAs}>
        <CustomInput
          id={id}
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onToggle?.(!e.target.checked)}
          name={name}
          disabled={isDisabled}
        />

        <CheckboxSquare>
          {(isChecked || indeterminate) && (
            <Icon
              type={indeterminate ? 'subtract-line' : 'check-line'}
              color={theme.neutral[0]}
              size={10}
            />
          )}
        </CheckboxSquare>
      </Label>
    </Container>
  );
};
